import { render, staticRenderFns } from "./EditLayoutActions.vue?vue&type=template&id=4c07c9ab&scoped=true"
import script from "./EditLayoutActions.vue?vue&type=script&lang=js"
export * from "./EditLayoutActions.vue?vue&type=script&lang=js"
import style0 from "./EditLayoutActions.vue?vue&type=style&index=0&id=4c07c9ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c07c9ab",
  null
  
)

export default component.exports